"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectionPosition = exports.ComponentInjectionManager = void 0;
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var ui_managers_1 = require("./ui-managers");
(0, kaltura_player_js_1.registerPlugin)(ui_managers_1.pluginName, ui_managers_1.UIManagers);
var component_injection_manager_1 = require("./services/component-injection-manager/component-injection-manager");
Object.defineProperty(exports, "ComponentInjectionManager", { enumerable: true, get: function () { return component_injection_manager_1.ComponentInjectionManager; } });
var models_1 = require("./services/component-injection-manager/models");
Object.defineProperty(exports, "InjectionPosition", { enumerable: true, get: function () { return models_1.InjectionPosition; } });
